/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { faCamera } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Loading } from "../../../../Helper/Loading";
import { MAX_IMAGE_HEIGHT, MAX_IMAGE_WIDTH } from "../../../image-utils";

export interface ManualImageProps {
    image: any;
}

export function ManualImage({ image }: ManualImageProps) {
    const placeholder = !image.url_webp;
    const timer = useRef<any>();
    const [isLoaded, setLoaded] = useState(false);
    const [dimensions, setDimensions] = useState([MAX_IMAGE_WIDTH, MAX_IMAGE_HEIGHT]);
    const [the_time_out, set_time_out] = useState(250);
    const loadImage = () => {
        const _image = new Image();
        _image.crossOrigin = "";
        _image.src = image.url_webp;

        _image.onload = () => {
            setDimensions([_image.width, _image.height]);
            setLoaded(true);
        };
        _image.onerror = () => {
            timer.current = setTimeout(() => loadImage(), get_time_out());
        };
    };


    const get_time_out = () => {
        const new_time_out = the_time_out + 250;
        set_time_out(new_time_out);
        return new_time_out;
    };

    // clear on component unmount
    useEffect(() => () => clearTimeout(timer.current), []);

    //! warning: canvas must be rendered for this to work, hence the ugly .d-none hack
    useEffect(() => {
        if (placeholder) {
            return;
        }
        loadImage();
    }, [placeholder]);
    const padding = (dimensions[1] / dimensions[0]) * 100;

    // !warning: please note that everything is absolute positioned inside the relative div. So we do not have ugly jumps between avocado loads.
    return <div css={css`max-width: 70rem;`} className="w-100">
        <div className="w-100 mx-auto" css={css`background: #f1f1f1; position: relative; padding-bottom: ${padding}%;`} >
            <div css={css`position:absolute; top: 50%; left: 50%; transform: translate(-50%,-50%)`}>
                {!placeholder && !isLoaded && <Loading />}
                {placeholder && <div >
                    <div className="text-center" css={css`opacity: 0.4; font-size: 150%;`}><FontAwesomeIcon icon={faCamera} /></div>
                    <div className="lead text-center text-uppercase d-none d-md-block" css={css`opacity: 0.6; font-size: 0.8rem; font-weight: bold;`}><small>Click to add Image</small></div>
                </div>}
            </div>
            {isLoaded && <img css={css`position:absolute; top: 0; bottom: 0; left: 0; right: 0; `} src={image.url_webp} alt={image.blob_name} className="w-100"></img>}
        </div>
    </div>;
}

